import type { Company } from "@/modules/companies/client/api/types"

export const getAssociatedCompaniesIds = (hasGroupOffers: boolean, company: Company): string[] => {
  return hasGroupOffers
    ? [
        ...company.page.associatedCompanies
          .filter(associatedCompany => associatedCompany.displayJobs)
          .map(associatedCompany => associatedCompany.id),
      ]
    : []
}
